import { GridOptions } from 'ag-grid-community';

export const SumBold: GridOptions = {
    getRowStyle: (params) => {
        if (params.node.footer) {
            return { fontWeight: 'bold' };
        }
    },
};
